import { Component, OnInit, Optional } from '@angular/core';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { SearchMode } from '../../../shared/enum/searchMode';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { GwrBauprojektSucheStandardComponent } from './gwr-bauprojekt-suche-standard/gwr-bauprojekt-suche-standard.component';
import { GwrBauprojektSucheDossiernummerComponent } from './gwr-bauprojekt-suche-dossiernummer/gwr-bauprojekt-suche-dossiernummer.component';
import { GwrBauprojektSucheEproidComponent } from './gwr-bauprojekt-suche-eproid/gwr-bauprojekt-suche-eproid.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-bauprojekt-suche',
  templateUrl: './gwr-bauprojekt-suche.component.html',
  styleUrls: ['./gwr-bauprojekt-suche.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    GwrBauprojektSucheStandardComponent,
    GwrBauprojektSucheDossiernummerComponent,
    GwrBauprojektSucheEproidComponent,
    NgbNavOutlet,
    TranslatePipe
  ]
})
export class GwrBauprojektSucheComponent implements OnInit {
  searchModeEnum = SearchMode;

  searchMode: SearchMode;

  constructor(
    private stateService: SearchStateService,
    @Optional() private metaDirective?: MetaDirective
  ) {
    keysToTranslate<string>(['gwrBauprojekt.BreadcrumbSuche']);
  }

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || SearchMode.searchStandard;
  }
}
